import { render, staticRenderFns } from "./ContextMenuHeader.vue?vue&type=template&id=1149cc55&"
var script = {}
import style0 from "./ContextMenuHeader.vue?vue&type=style&index=0&id=1149cc55&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports